import React from 'react';
import { connect } from 'react-redux';
import { Typography } from 'rmwc';
import { Text } from '../../components/Text';
import { enroll } from '../../actions/onboardingActions';
import { Card, CardActions, CardAction } from 'rmwc/Card';

export const CTAOpt = ({ title, subtitle, image, description, buttonText, onClick, style = {} }) => <div />;

export const CTAOptDense = ({
  title,
  subtitle,
  image,
  description,
  buttonTextPrimary,
  onClickPrimary,
  noSecondary,
  buttonTextSecondary,
  onClickSecondary,
  style = {},
}) => (
  <Card style={Object.assign({ width: '410px', marginRight: '1rem' }, style)}>
    <div className="pt-3 pl-3 pr-3 pb-1">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ marginLeft: 0 }}>
          <Typography tag="div" use="headline6">
            {title}
          </Typography>
          <Typography tag="div" theme="text-secondary-on-background" use="body1">
            {subtitle}
          </Typography>
        </div>
        <div style={{ width: '70px' }}>
          <img src={image} style={{ width: '70px' }} />
        </div>
      </div>
      <div>
        <Typography use="subheading1">{description}</Typography>
      </div>
    </div>
    <CardActions style={{ justifyContent: 'flex-end' }}>
      {noSecondary || (
        <CardAction onClick={onClickSecondary} theme="secondary">
          {buttonTextSecondary}
        </CardAction>
      )}
      <CardAction onClick={onClickPrimary} theme="secondary-bg on-primary">
        {buttonTextPrimary}
      </CardAction>
    </CardActions>
  </Card>
);
